import { render } from "./CompetitionStatisticsModal.vue?vue&type=template&id=b430ece2&scoped=true"
import script from "./CompetitionStatisticsModal.vue?vue&type=script&lang=js"
export * from "./CompetitionStatisticsModal.vue?vue&type=script&lang=js"

import "./CompetitionStatisticsModal.vue?vue&type=style&index=0&id=b430ece2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b430ece2"]])

export default __exports__